import { DimensionUnit, WeightUnit } from '@freight-cbm/shared-types';

export const dimUnitOptions = [
  { value: DimensionUnit.Cm, label: 'cm' },
  { value: DimensionUnit.In, label: 'in' },
  { value: DimensionUnit.M, label: 'm' },
  { value: DimensionUnit.Mm, label: 'mm' },
];

export const weightUnitOptions = [
  { value: WeightUnit.Kg, label: 'kg' },
  { value: WeightUnit.Lb, label: 'lb' },
];
